"use strict";

var SwiperFeatures = new Swiper('.features-container', {
  //need rewrite
  wrapperClass: "features-wrapper",
  slideClass: "features-slide",
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  }
});
var SwiperPartners = new Swiper('.partners__slider-container', {
  //need rewrite
  wrapperClass: "partners__slider-wrapper",
  slideClass: "partners__slider-slide",
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 2
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  }
});
var SwiperPartnersDesktop = new Swiper('.partners__slider-container-desktop', {
  //need rewrite
  wrapperClass: "partners__slider-wrapper-desktop",
  slideClass: "partners__slider-slide-desktop",
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var SwiperUserStory = new Swiper('.user-story-container', {
  //need rewrite
  lazy: true,
  wrapperClass: "user-story-wrapper",
  slideClass: "user-story-slide",
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  breakpoints: {
    768: {
      slidesPerView: 2
    }
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
if (SwiperUserStory) {
  var resizeSliders = function resizeSliders() {
    var wrapperSlider = document.querySelector(".user-story-wrapper");
    if (wrapperSlider) {
      var listSlider = document.querySelectorAll(".user-story-slide");
      var arrSliders = [];
      wrapperSlider.style.height = "auto";
      listSlider.forEach(function (item) {
        item.style.height = "auto";
        arrSliders.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(Math, arrSliders);
      wrapperSlider.style.height = maxHeight + 20 + "px";
    }
  };
  resizeSliders();
  window.addEventListener('resize', function (event) {
    resizeSliders();
  });
}
var SwiperProducts = new Swiper('.traveler-products-slider', {
  // need rewrite
  wrapperClass: "traveler-products-wrapper",
  slideClass: "traveler-products-slide",
  spaceBetween: 16,
  width: 208,
  loop: true,
  breakpoints: {
    768: {
      width: 280
    },
    1170: {
      slidesPerView: 1,
      width: 350,
      spaceBetween: 30
    }
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var SwiperTravelerPartners = new Swiper('.traveler-partners-slider', {
  // need rewrite
  wrapperClass: "traveler-partners-wrapper",
  slideClass: "traveler-partners-slide",
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  // width: 350,
  breakpoints: {
    320: {
      slidesPerView: 1
      // width: 285,
    },

    768: {
      slidesPerView: 2
      // width: 350,
    },

    992: {
      slidesPerView: 3,
      spaceBetween: 28
    }
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var SwiperCars = new Swiper('.slider-car__container', {
  // need rewrite
  wrapperClass: "slider-car__wrapper",
  slideClass: "slider-car__item",
  slidesPerView: 2,
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 3
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  }
});
var SwiperCarsNew = new Swiper('.slider-car__container-new', {
  // need rewrite
  wrapperClass: "slider-car__wrapper-new",
  slideClass: "slider-car__item-new",
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoHeight: true,
  breakpoints: {
    992: {
      autoHeight: false
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  }
});
var sliderCarItemNew = document.querySelectorAll(".slider-car__item-new");
var featuresNavigationBlock = document.querySelector(".features-navigation-new");
if (sliderCarItemNew.length <= 1 && featuresNavigationBlock) {
  featuresNavigationBlock.style.display = "none";
  console.log("test slider");
}
var SwiperSliderService = new Swiper('.service-slider__container', {
  // need rewrite
  wrapperClass: "service-slider__wrapper",
  slideClass: "service-slider__item",
  slidesPerView: 2,
  loop: true,
  spaceBetween: 36,
  breakpoints: {
    480: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 5
    },
    992: {
      slidesPerView: 6
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  }
});
var SwiperInstagram = new Swiper('.instagram-container', {
  //need rewrite
  lazy: true,
  wrapperClass: "instagram-wrapper",
  slideClass: "instagram-slide",
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  breakpoints: {
    768: {
      slidesPerView: 2
    }
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 1
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var SwiperWhyChoose = new Swiper('.why-choose-slide-container', {
  //need rewrite
  lazy: true,
  wrapperClass: "why-choose-slide-wrapper",
  slideClass: "why-choose-slide-slide",
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  breakpoints: {
    320: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    }
  },
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 3
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
var CustomSpeak = document.querySelector('.customer-speak');
if (CustomSpeak) {
  var SwiperCustomerSpeak = new Swiper('.customer-speak-container', {
    //need rewrite
    lazy: true,
    wrapperClass: "customer-speak-wrapper",
    slideClass: "customer-speak-slide",
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 3
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
  var wrapperSlider = document.querySelector(".customer-speak-wrapper");
  if (wrapperSlider) {
    var listSlider = document.querySelectorAll(".customer-speak-slide");
    var arrSliders = [];
    wrapperSlider.style.height = "auto";
    listSlider.forEach(function (item) {
      item.style.height = "auto";
      arrSliders.push(item.offsetHeight);
    });
    var maxHeight = Math.max.apply(Math, arrSliders);
    wrapperSlider.style.height = maxHeight + 20 + "px";
  }
}
var newFeatureSlider = document.querySelector('.new-feature');
if (newFeatureSlider) {
  var newFeatureSliders = new Swiper(".new-feature-slider", {
    direction: "vertical",
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    }
  });
}
var ourServicesNew = document.querySelector('.our-services--new');
if (ourServicesNew) {
  var ourServices = new Swiper('.our-services--new--content', {
    lazy: true,
    wrapperClass: "our-services--new--wrapper",
    slideClass: "our-services--new--slide",
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 1
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}
var latestNews = document.querySelector('.latest-news--slider');
if (latestNews) {
  var _latestNews = new Swiper('.latest-news-container', {
    lazy: true,
    wrapperClass: "latest-news-wrapper",
    slideClass: "latest-news-slide",
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 1
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}